
import { currencyFormatterHelper } from '../../../../../../helpers/currencyFormatterHelper';
import { DateHelper } from '../../../../../../helpers/dateHelper';

export const initializeColumns = (t) => {
	return [
		{
			header: t('period'),
			accessorKey: 'number',
			size: 80
		},
		{
			header: t('dueDate'),
			accessorKey: 'dueDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'MMM dd, yyyy hh:mm');
			},
			size: 80
		},

		{
			header: t('amount'),
			accessorKey: 'amount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80
		},
		{
			header: t('total'),
			accessorKey: 'total',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80
		},
		{
			header: t('principal'),
			accessorKey: 'principal',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80
		},
		{
			header: t('investorProfit'),
			accessorKey: 'investorProfit',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80
		},
		{
			header: t('status'),
			accessorKey: 'status',
			size: 80
		},
	];
};
